// extracted by mini-css-extract-plugin
export default {"SingleLineCell":"SingleLineCell__EQsxkuidkRYI"};